import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import Layout from '../components/layout/Layout';
import { projects, projectCategories } from '../data/mock';
import FAQSection from '../components/home/FAQSection';
import StarburstDecor from '../components/ui/StarburstDecor';

const ProjectsPage = () => {
  const [activeCategory, setActiveCategory] = useState('All Project');

  const filteredProjects = activeCategory === 'All Project'
    ? projects
    : projects.filter((p) => p.category === activeCategory);

  return (
    <Layout>
      {/* Hero */}
      <section className="bg-white py-16 relative">
        <div className="container-main">
          <div className="max-w-2xl">
            <h1 className="text-4xl md:text-5xl font-bold text-navy leading-tight">
              We take digital<br />experiences to the<br />next level
            </h1>
          </div>
          <div className="absolute top-8 right-8 hidden lg:block">
            <StarburstDecor size={100} />
          </div>
        </div>
      </section>

      {/* Filter Tabs */}
      <section className="bg-white pb-8">
        <div className="container-main">
          <div className="flex flex-wrap gap-3">
            {projectCategories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-4 py-2 text-sm font-medium rounded-full border transition-colors ${
                  activeCategory === category
                    ? 'bg-navy text-white border-navy'
                    : 'bg-white text-navy border-gray-200 hover:border-navy'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="bg-white py-12">
        <div className="container-main">
          <div className="grid md:grid-cols-2 gap-6">
            {filteredProjects.map((project) => (
              <Link
                key={project.id}
                to={`/projects/${project.id}`}
                className="group relative overflow-hidden rounded-lg aspect-[4/3]"
              >
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/90 via-navy/40 to-transparent" />
                <div className="absolute top-4 left-4">
                  <h3 className="text-xl font-semibold text-white">{project.title}</h3>
                  <p className="text-white/60 text-sm">{project.category}</p>
                </div>
                <div className="absolute bottom-4 left-4">
                  <span className="inline-flex items-center gap-2 text-lime text-sm font-medium">
                    Get Explore
                    <ArrowUpRight className="w-4 h-4" />
                  </span>
                </div>
                <div className="absolute top-4 right-4 w-10 h-10 bg-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <ArrowUpRight className="w-5 h-5 text-navy" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <FAQSection />
    </Layout>
  );
};

export default ProjectsPage;
